import { ProgressIndicator, Spinner } from "../../../../../widgets"
import { DocumentChecklist } from "../../../document-checklist/DocumentChecklist"
import { MultiTypeDocument } from "../../../document-checklist/MultiTypeDocument"

export const MultiTypeDocumentAttribute = ({
    attributeId,
    required,
    entity,
    entityId,
    relativePath,
    readOnly,
    className,
}: {
    attributeId: string,
    entity?: string,
    entityId?: string,
    required?: boolean,
    checklistId?: string,
    relativePath?: string,
    readOnly?: boolean,
    className?: string,
}) => {

    if (!attributeId || !entity || !entityId || !relativePath) return <Spinner show={true} />;

    return <>
        <MultiTypeDocument
            className={className}
            readonly={readOnly}
            entityId={entityId}
            entity={entity}
            required={required}
            fieldId={attributeId}
            relativePath={relativePath || ''}
        // checklistId={checklistId} 
        />
    </>
}
